import { render } from "./team-management.view.vue?vue&type=template&id=0b09c000&scoped=true&ts=true"
import script from "./team-management.view.vue?vue&type=script&lang=ts"
export * from "./team-management.view.vue?vue&type=script&lang=ts"

import "./team-management.view.vue?vue&type=style&index=0&id=0b09c000&lang=scss&scoped=true"
import "./team-management.view.vue?vue&type=style&index=1&id=0b09c000&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b09c000"]])

export default __exports__